// import { useMemo, useState } from 'react';

// const useSortableData = (items: any[], config = null) => {
// 	const [sortConfig, setSortConfig] = useState(config);

// 	const sortedItems = useMemo(() => {
// 		const sortableItems = [...items];
// 		if (sortConfig !== null) {
// 			sortableItems.sort((a, b) => {
// 				// @ts-ignore
// 				if (a[sortConfig.key] < b[sortConfig.key]) {
// 					// @ts-ignore
// 					return sortConfig.direction === 'ascending' ? -1 : 1;
// 				}
// 				// @ts-ignore
// 				if (a[sortConfig.key] > b[sortConfig.key]) {
// 					// @ts-ignore
// 					return sortConfig.direction === 'ascending' ? 1 : -1;
// 				}
// 				return 0;
// 			});
// 		}
// 		return sortableItems;
// 	}, [items, sortConfig]);

// 	const requestSort = (key: any) => {
// 		let direction = 'ascending';
// 		// @ts-ignore
// 		if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
// 			direction = 'descending';
// 		}
// 		// @ts-ignore
// 		setSortConfig({ key, direction });
// 	};

// 	const getClassNamesFor = (key: any) => {
// 		if (!sortConfig) {
// 			return 'd-none';
// 		}
// 		// eslint-disable-next-line consistent-return
// 		// @ts-ignore
// 		return sortConfig.key === key ? sortConfig.direction : 'd-none';
// 	};

// 	return { items: sortedItems, requestSort, getClassNamesFor, sortConfig };
// };

// export default useSortableData;
import { useMemo, useState } from 'react';

const useSortableData = (items: any[], config = null) => {
	const [sortConfig, setSortConfig] = useState(config);

	const getNestedValue = (obj: any, key: string) => {
		return key.split('.').reduce((acc, part) => acc && acc[part], obj);
	};

	const sortedItems = useMemo(() => {
		const sortableItems = [...items];
		if (sortConfig !== null) {
			sortableItems.sort((a, b) => {
				// @ts-ignore
				const aValue = getNestedValue(a, sortConfig.key);
				// @ts-ignore
				const bValue = getNestedValue(b, sortConfig.key);

				if (aValue < bValue) {
					// @ts-ignore
					return sortConfig.direction === 'ascending' ? -1 : 1;
				}
				if (aValue > bValue) {
					// @ts-ignore
					return sortConfig.direction === 'ascending' ? 1 : -1;
				}
				return 0;
			});
		}
		return sortableItems;
	}, [items, sortConfig]);

	const requestSort = (key: string) => {
		let direction = 'ascending';
		// @ts-ignore
		if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
			direction = 'descending';
		}
		// @ts-ignore
		setSortConfig({ key, direction });
	};

	const getClassNamesFor = (key: string) => {
		if (!sortConfig) return 'd-none';
		// @ts-ignore
		return sortConfig.key === key ? sortConfig.direction : 'd-none';
	};
	const getSortIcon = (key: string) => {
		// @ts-ignore
		if (!sortConfig) return 'ArrowUpward'; // Show default icon if nothing is sorted yet
		// @ts-ignore
		if (sortConfig.key === key) {
			// @ts-ignore
			return sortConfig.direction === 'ascending' ? 'ArrowUpward' : 'ArrowDownward';
		}
		return 'ArrowUpward'; // Default icon for other columns
	};



	return { items: sortedItems, requestSort, getClassNamesFor, sortConfig, getSortIcon };
};

export default useSortableData;
